var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"dense":"","items":_vm.departamentos},on:{"change":_vm.selectDepartment},model:{value:(_vm.department),callback:function ($$v) {_vm.department=$$v},expression:"department"}})
}
var staticRenderFns = []

export { render, staticRenderFns }